<template>
  <div id="app"  :key="componentKey">
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>

import { i18n } from './plugins/i18n.js'
import { mapGetters, mapActions } from 'vuex';
const default_layout = "default";


export default {
  name: "EasyGrader",

  data() {
    return {
      componentKey: 0,
    };
  },


  metaInfo() {
    return {
      title: i18n.t('meta_fields.title'),
      titleTemplate: '%s | ' + this.settings.brand.brand_name,
      htmlAttrs: {
        lang: this.$i18n.locale
      },
      meta: [
        { charset: 'utf-8' },
        { description: i18n.t('meta_fields.description') }
      ]
    }
  },

  async created() {
    await this.getOrCreateSetting();
    if (this.should_refresh){
      // vm.$forceUpdate();
      // this.$forceUpdate(); // Todo : maybe we should refresh the app (more probably it'll be done in src/store/settings/index.js)
    }
  },

  methods: {
    ...mapActions({
      getOrCreateSetting: 'settings/getOrCreateSetting',
    }),

    forceRerender() {
      this.componentKey += 1; // TODO See : https://michaelnthiessen.com/force-re-render/
    }
  },

  mounted() {
    // Set the CSS variable for all app components
    this.$el.style.setProperty('--colorPrimary', this.settings.colors.primary) ;
    this.$el.style.setProperty('--colorSecondary', this.settings.colors.secondary) ;
    },

  // metaInfo: {
  //     // if no subcomponents specify a metaInfo.title, this title will be used
  //     title: this.metaInfoTitle,
  //     // all titles will be injected into this template
  //     titleTemplate: '%s | Quiz'
  //   },
  // data() {
  //   return {
  //     // metaInfoTitle: this.$i18n.messages[this.$i18n.locale].page_title
  //     // metaInfoTitle: this.$i18n.locale
  //     metaInfoTitle: i18n.t('meta_fields.title')
  //   }
  // },
  computed: {

    ...mapGetters('settings', {
        settings: 'settings',
        should_refresh: 'shouldRefresh'
      }),

    layout(){
      return (this.$route.meta.layout || default_layout) + '-layout';
    }
  }

}
</script>

<style>


.btn-secondary {
  background-color: var(--colorSecondary)!important;
  border-color: var(--colorSecondary)!important;
  border-width: 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.btn-secondary:hover{
  background-color: var(--colorPrimary)!important;
  border-color: var(--colorSecondary)!important;
  color: #fff!important;
}

.btn-secondary, .btn-secondary a {
  /*color: var(--colorPrimary)!important;*/
  color: #fff!important;
}


.masthead img {
  max-width: 200px;
  padding-top: 30px;
}

.mastfoot {
  color: #eee;
}
.mastfoot a, .mastfoot a:hover {
  color: #b9ae3f;
}



  .gray-app {
    background: #EFF3F4;
    font-family: 'Open Sans', serif;
  }

  .is-anthracite {
    background-color: #444;
  }

  .navbar{
    height: 120px;
  }
  .navbar-item img {
      max-height: 70px;
  }
  .hero-body.container {
    max-width: 700px;
    padding: 30px;
    margin-bottom: 40px;
  }
  .hero-body .title {
    color: hsl(192,17%,99%) !important;
    font-size: 2.2em;
  }
  .hero-body .subtitle {
    color: hsl(192,17%,99%) !important;
    padding-top: 2rem;
    line-height: 1.5;
    font-size: 1.8em;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue